export class Geometry {
  constructor(geometry: Geometry) {
    this.x = geometry.x;
    this.y = geometry.y;
    if (geometry.latitude === undefined) {
      this.latitude = geometry.y;
    } else {
      this.latitude = geometry.latitude;
    }
    if (geometry.longitude === undefined) {
      this.longitude = geometry.x;
    } else {
      this.longitude = geometry.longitude;
    }
  }
  x: number;
  y: number;
  latitude: number;
  longitude: number;
}
